<template>
  <div id="divSummary">
    <div class="Flex_Table tblEntryForm" style="margin-left: 5px; margin-bottom: 3px">
      <div class="Flex_Row">
        <div class="Flex_Cell" width="30%">
          <span>Booking Type</span>
          <select id="ddlBookingType" v-model="bookingTypeID" v-on:change="GetShowMyBookings()">
            <option
              v-for="m in bookingTypeList"
              :key="m.bookingTypeID"
              v-bind:value="m.bookingTypeID"
            >{{ m.bookingTypeName }}</option>
          </select>
        </div>
        <div class="Flex_Cell" width="70%"></div>
      </div>
    </div>
    <div class="Flex_Table tblEntryForm" style="margin-left: 5px; margin-bottom: 3px">
      <div class="Flex_Row">
        <div class="Flex_Cell_Inline">
          <span>Booking Type</span>
        </div>
        <div class="Flex_Cell_Inline"></div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell_Inline"></div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell_Inline">
          <span
            :class="selectTab1 ? 'tabSelectClass' : 'tabClass'"
            v-on:click="tabClick(1)"
          >Past Booking</span>
        </div>
        <div class="Flex_Cell_Inline">
          <span
            :class="selectTab2 ? 'tabSelectClass' : 'tabClass'"
            v-on:click="tabClick(2)"
          >Upcoming Booking</span>
        </div>
      </div>
    </div>
    <div class="Flex_Table" v-show="selectTab1">
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <div class="cards-list">
            <div class="cards" v-for="bl in showMyBookings_List_Past" :key="bl.bookingID">
              <div class="Flex_Row">
                <div class="Flex_Cell" align="center">
                  <img
                    id="QRCode"
                    :src="'data:image/jpeg;base64,' + bl.qrCode"
                    style="height: 150px; width: 150px;padding: 10px"
                  />
                </div>
                <div class="Flex_Cell">{{ bl.bookingDates }} {{ bl.slotDetails }}</div>
                <div class="Flex_Cell">
                  <span style="font-size:20px;">
                    <b>{{ bl.noOfIndividuals }}</b>
                  </span> Person(s)
                </div>
                <div class="Flex_Cell">Total Amount : &#8377{{ bl.totalAmount }}</div>
                <div class="Flex_Cell">Ref. No : {{ bl.refNo }}</div>
                <div class="Flex_Cell">Ticket No : {{ bl.ticketNo }}</div>
                <div class="Flex_Cell">
                  Ticket Status :
                  <span
                    style="color: green;"
                    v-if="bl.isPaymentRefunded == 0"
                  >Ticket Booked</span>
                  <span style="color: orange;" v-if="bl.isPaymentRefunded == 2">Refund Initiated</span>
                  <span style="color: green;" v-if="bl.isPaymentRefunded == 1">Amount Refunded</span>
                </div>
              </div>
              <div class="Flex_Row" align="center">
                <input
                  type="button"
                  v-on:click="printTicketForm(bl.refNo)"
                  value="Show Ticket"
                  style="padding: 5px;width:50%"
                  title="Click Here to Show Ticket"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="Flex_Table" v-show="selectTab2">
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <div class="cards-list">
            <div class="cards" v-for="bl in showMyBookings_List_UpComming" :key="bl.bookingID">
              <div class="Flex_Row">
                <div class="Flex_Cell" align="center">
                  <img
                    id="QRCode"
                    :src="'data:image/jpeg;base64,' + bl.qrCode"
                    style="height: 150px; width: 150px;padding: 10px"
                  />
                </div>
                <div class="Flex_Cell">{{ bl.bookingDates }} {{ bl.slotDetails }}</div>
                <div class="Flex_Cell">
                  <span style="font-size:20px;">
                    <b>{{ bl.noOfIndividuals }}</b>
                  </span> Person(s)
                </div>
                <div class="Flex_Cell">Total Amount : &#8377{{ bl.totalAmount }}</div>
                <div class="Flex_Cell">Ref. No : {{ bl.refNo }}</div>
                <div class="Flex_Cell">Ticket No : {{ bl.ticketNo }}</div>
                <div class="Flex_Cell">
                  Ticket Status :
                  <span
                    style="color: green;"
                    v-if="bl.isPaymentRefunded == 0"
                  >Ticket Booked</span>
                  <span style="color: orange;" v-if="bl.isPaymentRefunded == 2">Refund Initiated</span>
                  <span style="color: green;" v-if="bl.isPaymentRefunded == 1">Amount Refunded</span>
                </div>
              </div>
              <div class="Flex_Row" align="center">
                <input
                  type="button"
                  v-on:click="printTicketForm(bl.refNo)"
                  value="Show Ticket"
                  style="padding: 5px;width:50%"
                  title="Click Here to Show Ticket"
                />
                <input
                  type="button"
                  value="Cancel Ticket"
                  v-on:click="confirmCancel1(bl)"
                  style="padding: 5px;display: inline;background-color: red;"
                  v-if="bl.refundCanBeMade == 1"
                  title="Click to Cancel Ticket"
                />
                <!-- <input
                  type="button"
                  value="Check Refund"
                  v-on:click="GetFailedPayment(bl)"
                  style="padding: 5px;display: inline;background-color: red;"
                  title="Click to Check Refund"
                />-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalPopup
      title="Ticket Print"
      ref="ModalPopup1"
      @closed="modalPopupClosed"
      @opened="modalPopupShown"
      v-model="ticketPrintDiv"
      :okButton="$refs.btnOk"
      :cancelButton="$refs.btnOk"
      v-if="TicketNo != ''"
      class="tblEntryForm"
    >
      <div style="height: calc(90vh - 100px); width:100%;">
        <PrintTicket :TicketNo="TicketNo" :eventBus="printbus" :key="TicketNo"></PrintTicket>
      </div>
      <div style="text-align: center;" class="background">
        <!-- <input type="button" value="Print" v-on:click="printPDFReport()" />         -->
      </div>
    </ModalPopup>
  </div>
</template>
<script>
import vue from "vue";
import config from "@/router/globalConfig";
import DateControl from "./ekkControls/DateControl";
import PrintTicket from "@/components/PrintTicket";
import ModalPopup from "./ekkControls/ModalPopup";
import MyBookingJS from "./servicesJS/MyBooking.js";
import MasterJS from "./servicesJS/Master.js";
import TicketJS from "./servicesJS/Ticket.js";
export default {
  name: "MyBooking",
  components: {
    DateControl: DateControl,
    PrintTicket: PrintTicket,
    ModalPopup: ModalPopup
  },
  data() {
    return {
      showPopup: false,
      showBackGround: false,
      popHeader: "Pop Header Text Come",
      withDates: false,
      advtID: -1,
      advt_List: [],
      showMyBookings_List: [],
      statusDetail_List: [],
      fromDate: new Date(),
      toDate: new Date(),
      popPostTypeID: -1,
      popType: 1,
      showMyBookings_List_Past: [],
      showMyBookings_List_UpComming: [],
      selectTab1: false,
      selectTab2: true,
      bookingTypeList: [],
      bookingTypeID: 1,
      //bookingTypeIDddl: -1
      printbus: new vue(),
      ticketPrintDiv: false,
      TicketNo: "",
      isTicketPrinted: 0,
      refundCanBeMade: 0,
      ticketDetailsForCancel: [],
      cancelReason: "",
      isRefund: null
    };
  },
  methods: {
    // getAdvertisment() {
    //   this.advt_List = [];
    //   const _data_ = { type: 1 };
    //   axios
    //     .get(config.WEB_API_PATH + "Master/GetAdvertisment", {
    //       headers: {
    //         __RequestVerificationToken: config.AF_Token,
    //         Authorization: config.LOG_Token
    //       },
    //       params: _data_,
    //       crossdomain: true
    //     })
    //     .then(
    //       response => {
    //         this.advt_List = response.data;
    //         if (response.data.length > 0) {
    //           this.advtID = response.data[0][0];
    //           this.fromDate = new Date(response.data[0][2]);
    //           this.getStatusSummary();
    //         }
    //       },
    //       error => {}
    //     );
    // },
    GetShowMyBookings() {
      this.showMyBookings_List = [];
      //alert("bookingTypeID : " + this.bookingTypeID);
      const _data_ = {
        bookingTypeID: this.bookingTypeID,
        type: 1
      };
      MyBookingJS.ShowMyBooking(_data_).then(
        response => {
          this.showMyBookings_List = response.data;
          this.showMyBookings_List_Past = this.showMyBookings_List.filter(
            item => {
              return item.bookingStatusID == 0;
            }
          );
          this.showMyBookings_List_Past = this.showMyBookings_List_Past.filter(
            item => {
              return item.ticketPrinted == 1;
            }
          );
          this.showMyBookings_List_UpComming = this.showMyBookings_List.filter(
            item => {
              return item.bookingStatusID == 1;
            }
          );
          this.showMyBookings_List_UpComming = this.showMyBookings_List_UpComming.filter(
            item => {
              return item.ticketPrinted == 1;
            }
          );
        },
        error => {}
      );
    },

    tabClick(type) {
      this.selectTab1 = false;
      this.selectTab2 = false;
      this.whichTabSelected = type;
      if (type == 1) {
        this.selectTab1 = true;
        this.GetShowMyBookings();
        this.showMyBookings_List_UpComming = [];
      }
      if (type == 2) {
        this.selectTab2 = true;
        this.GetShowMyBookings();
        this.showMyBookings_List_Past = [];
        // this.getExamType();
        // this.getPostType();
        // this.seatingPlan_List = [];
      }
    },
    getbookingTypeList() {
      if (this.isRefund == true) {
        MessageBox.show({
          message:
            "Ticket has been Cancelled and Refund has been Initiated. The refund amount will be credited within 4 to 7 working days after the refund is initiate into the original payment mode that was used for booking the ticket. In case of any issue, the tourists are requested to send an e-mail with the Ticket No, Name and Mobile No. through which ticket was booked on bro-rtg[at]nic[dot]in",
          type: "success",
          title: "Success"
        });
        this.$root.$data.isRefund = null;
      } else if (this.isRefund == false) {
        MessageBox.show({
          message:
            "Ticket Cancellation failed. Please try again later. In case of any issue, the tourists are requested to send an e-mail with the Ticket No, Name and Mobile No. through which ticket was booked on bro-rtg[at]nic[dot]in",
          type: "error",
          title: "Error"
        });
        this.$root.$data.isRefund = null;
      }
      const _data_ = { isActive: 1, type: 1 };
      MasterJS.getBookingTypes(_data_).then(
        response => {
          this.bookingTypeList = response.data;
          this.bookingTypeID = response.data[0].bookingTypeID;
          this.GetShowMyBookings();
          //alert(this.typeID);
        },
        error => {}
      );
    },

    printPDFReport() {
      this.printbus.$emit("printPDF");
    },
    modalPopupShown(e) {
      //this.printPDFReport();
    },
    modalPopupClosed(e) {
      this.printbus = new vue();
    },
    printTicketForm(TicketNo) {
      this.TicketNo = TicketNo;
      let self = this;
      vue.nextTick(function() {
        self.printbus.$emit("PrintTicket");
        self.ticketPrintDiv = true;
      });
    },
    GetFailedPayment(bl) {
      const _data_ = {
        bookingID: bl.bookingID
      };
      MyBookingJS.GetFailedPayment(_data_).then(response => {
        // console.log(response.data);
      });
    },
    confirmCancel1(bl) {
      this.ticketDetailsForCancel = bl;
      MessageBox.show(
        {
          message:
            "Cancel Reason<br/><textarea type='text' id='cancelReason'></textarea><br/>Are you sure to cancel the ticket  ? </br> Click  Yes to continue",
          type: "confirm",
          title: "Confirmation",
          defaultButton: 2
        },
        {
          buttonName: "Yes",
          buttonAction: this.confirmCancel2
        },
        { buttonName: "No", buttonAction: this.showFlashMessage }
      );
    },
    confirmCancel2() {
      if ($("#cancelReason").val() == "") {
        MessageBox.show({
          message: "Please Enter Reason for cancel the ticket",
          type: "confirm",
          title: "Alert"
        });
        return;
      } else {
        this.cancelReason = $("#cancelReason").val();
        MessageBox.show(
          {
            message:
              "Once, you cancel the ticket, </br> it cannot be reverted.",
            type: "confirm",
            title: "Alert",
            defaultButton: 2
          },
          {
            buttonName: "Yes",
            buttonAction: this.goToCancelTicket
          },
          { buttonName: "No", buttonAction: this.showFlashMessage }
        );
      }
    },
    goToCancelTicket() {
      this.$root.$data.BookingID = this.ticketDetailsForCancel.bookingID;
      this.$root.$data.CancelReason = this.cancelReason;
      this.$root.$data.PageName = "MyBooking";
      this.$router.push({ name: "RefundRequest" });
    },
    PrintTicket() {
      if (this.TicketNo == "") {
        alert("Enter ticket No.");
        return;
      }
      const _data_ = {
        BookingID: this.BookingID,
        TicketNo: this.TicketNo,
        FormID: -1,
        type: 1
      };
      TicketJS.GetPrintTicket(_data_).then(
        response => {
          if (response.data.length > 0) {
            if (this.lstPrintTicket.bookingID != 0) {
              this.lstPrintTicket = response.data[0];
              this.IsShow = true;
            }
          } else {
            this.ClearPrintTicket();
            alert("Not Found!");
          }
        },
        error => {}
      );
    }
  },
  computed: {},
  mounted() {
    //this.getAdvertisment();
    let self = this;
    if (self.$root.$data.isRefund != null) {
      this.isRefund = self.$root.$data.isRefund;
    }
    this.getbookingTypeList();
  },
  watch: {}
};
</script>
<style scoped>
.cards-list {
  padding: 10px;
  display: flex;
  border: 2px solid lightgray;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.cards {
  margin: 10px;
  padding-bottom: 10px;
  border: 2px solid lightgray;
  transition: 0.3s !important;
  border-radius: 5px;
}
.cards:hover {
  box-shadow: 0 8px 16px 0 rbga(0, 0, 0, 0.2);
  background-color: #ffa50069;
}
#background {
  background: url("../assets/images/logoa.png");
}

.myhead::-webkit-scrollbar {
  background-color: transparent;
}

.myhead::scrollbar {
  background-color: transparent;
}

.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}

#divSummary {
  margin-left: 4px;
  margin-right: 5px;
  /* border: dotted 1px darkgray;
        border-radius: 5px;
        padding: 5px 0px 0px 5px; */
}

.ekkGrid > .Flex_Row:hover:not(.GridHeader),
.ekkGrid > .GridContent > .Flex_Row:hover:not(.GridHeader) {
  background-color: #ffa50069;
  color: black;
}
</style>
<style scoped>
.fade-enter-active {
  animation: fade-in 0.4s;
}

.fade-leave-active {
  animation: fade-in 0.4s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  5% {
    opacity: 0.05;
  }

  10% {
    opacity: 0.1;
  }

  20% {
    opacity: 0.2;
  }

  25% {
    opacity: 0.25;
  }

  30% {
    opacity: 0.3;
  }

  35% {
    opacity: 0.35;
  }

  40% {
    opacity: 0.4;
  }

  45% {
    opacity: 0.45;
  }

  50% {
    opacity: 0.5;
  }

  55% {
    opacity: 0.55;
  }

  60% {
    opacity: 0.6;
  }

  65% {
    opacity: 0.65;
  }

  70% {
    opacity: 0.7;
  }

  75% {
    opacity: 0.75;
  }

  80% {
    opacity: 0.8;
  }

  85% {
    opacity: 0.85;
  }

  90% {
    opacity: 0.9;
  }

  95% {
    opacity: 0.95;
  }

  100% {
    opacity: 1;
  }
}
</style>
<style scoped>
.backgroundPopup {
  position: fixed;
  _position: absolute;
  /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}

.PopUpCover {
  border: solid 1px;
  border-radius: 4px;
  top: 110px;
  position: absolute;
  min-height: 256px;
  right: 380px;
  /* background-color: ;rgba(255, 248, 248, 0.86); */
  background-color: ghostwhite;
  -webkit-box-shadow: 1px 1px 20px 1px white;
  box-shadow: 1px 1px 20px 1px white;
  border-radius: 8px 8px 8px 8px;
  z-index: 2;
  color: black !important;
  width: 600px;
}

.PopUpDetail {
  padding: 10px;
  /* min-height: 200px;
        max-height: 400px; */
  overflow: auto;
}

.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 38px;
  border-bottom: solid 1px;
  border-radius: 8px;
}

.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}

.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}

.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}

.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px; */
  background-color: white;
  color: Black;
}

.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px black; */
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}

@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }

  25% {
    transform: scale(0.25);
  }

  50% {
    transform: scale(0.5);
  }

  75% {
    transform: scale(0.75);
  }

  100% {
    transform: scale(1);
  }
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .EntryBlock {
    width: 80%;
  }

  #divApplication {
    display: block;
    height: auto;
  }

  #location {
    width: 70%;
  }

  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }

  .EntryBlock {
    width: 100%;
  }

  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }

  .tblEntryForm {
    width: calc(100vw - 35px);
  }

  /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  }

  /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  }

  /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  }

  /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }

  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }

  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .EntryBlock {
    width: calc(100vw - 35px);
  }

  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }

  #location {
    width: 70%;
  }

  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }

  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }

  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }

  .tblEntryForm .divHR {
    display: block;
  }

  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }

  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyBooking.vue